import { format, isToday, isYesterday, differenceInDays } from "date-fns";
import { ptBR } from "date-fns/locale";

const formateDate = (date: any, formate?: string) => {
  const dateObj = new Date(date);
  const dateFormat = formate ? formate : "MM/dd/yyyy";
  const formattedDate = format(dateObj, dateFormat);
  return formattedDate;
};
export { formateDate };

// src/utils/dateHelpers.ts
// Utilitários de data/tempo usados pelo Chat (sem dependências externas).
// Formatos: pt-BR. Ajuste se preferir outro locale.

const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);

/**
 * Converte uma Date | string | IMessage.createdAt para timestamp (ms)
 */
export const toTimestamp = (
  input: Date | string | { createdAt?: string } | any,
): number => {
  if (!input) return 0;

  if (typeof input === "object" && input.createdAt) {
    input = input.createdAt;
  }

  if (input instanceof Date) {
    return input.getTime();
  }

  // assume string
  const d = new Date(input);
  return isNaN(d.getTime()) ? 0 : d.getTime();
};

/**
 * Retorna "Hoje", "Ontem" ou "dd/MM/yyyy" para agrupar mensagens
 * Utiliza data local (timezone do navegador)
 */
export const formatGroupDate = (date: Date | string): string => {
  const d = typeof date === "string" ? new Date(date) : date;

  if (!d || isNaN(d.getTime())) return "";

  const now = new Date();
  const startOfToday = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
  );
  const startOfYesterday = new Date(
    startOfToday.getTime() - 24 * 60 * 60 * 1000,
  );

  // normalize to midnight for comparison
  const target = new Date(d.getFullYear(), d.getMonth(), d.getDate());

  if (target.getTime() === startOfToday.getTime()) return "Hoje";
  if (target.getTime() === startOfYesterday.getTime()) return "Ontem";

  // default format dd/MM/yyyy
  const day = pad(d.getDate());
  const month = pad(d.getMonth() + 1);
  const year = d.getFullYear();

  return `${day}/${month}/${year}`;
};

/**
 * Formata hora no formato HH:mm (24h)
 */
export const formatTime = (date: Date | string): string => {
  const d = typeof date === "string" ? new Date(date) : date;
  if (!d || isNaN(d.getTime())) return "";
  const hours = pad(d.getHours());
  const minutes = pad(d.getMinutes());
  return `${hours}:${minutes}`;
};

/**
 * Formata data em dd/MM/yyyy
 */
export const formatDate = (date: Date | string): string => {
  const d = typeof date === "string" ? new Date(date) : date;
  if (!d || isNaN(d.getTime())) return "";
  const day = pad(d.getDate());
  const month = pad(d.getMonth() + 1);
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatCellphone = (value: string): string => {
  if (!value) return "";

  // Remove tudo que não for número
  let digits = value.replace(/\D/g, "");

  // Remove DDI brasileiro "55"
  if (digits.startsWith("55") && digits.length > 11) {
    digits = digits.substring(2);
  }

  // Ex: 11987654321 → (11) 98765-4321
  if (digits.length === 11) {
    return digits.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }

  // Ex: 1187654321 → (11) 8765-4321
  if (digits.length === 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }

  // fallback
  return value;
};

export const resolveLastMessageTime = (
  existing?: string,
  incoming?: string,
) => {
  if (incoming && incoming !== "0001-01-01T00:00:00") {
    return incoming;
  }

  return existing;
};

export const toTimestampSafe = (t?: string | number) => {
  if (!t) return 0;
  return typeof t === "number" ? t : new Date(t).getTime();
};

export const formatMessageDate = (data: string) => {
  // if (!t) return 0;
  const messageDate = new Date(data);

  let dateMessage = "";

  if (isToday(messageDate)) {
    dateMessage = format(messageDate, "HH:mm");
  } else if (isYesterday(messageDate)) {
    dateMessage = `Ontem às ${format(messageDate, "HH:mm")}`;
  } else if (differenceInDays(new Date(), messageDate) <= 7) {
    dateMessage = format(messageDate, "EEEE 'às' HH:mm", { locale: ptBR });
  } else {
    dateMessage = format(messageDate, "dd/MM/yyyy 'às' HH:mm");
  }

  return dateMessage;
};
